var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampaignRecommendations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 100,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.992 142.851H52.1367V85.6638C52.1367 84.5446 53.0428 83.6385 54.162 83.6385H144.073C145.192 83.6385 146.098 84.5446 146.098 85.6638V142.851H145.992Z",
    fill: "#1E334E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.26 139.12H56.892C56.3058 139.12 55.8794 138.64 55.8794 138.107V88.435C55.8794 87.8487 56.3591 87.4224 56.892 87.4224H141.26C141.847 87.4224 142.273 87.902 142.273 88.435V138.107C142.273 138.64 141.793 139.12 141.26 139.12Z",
    fill: "#939393"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141.26 139.12H56.892C56.3058 139.12 55.8794 138.64 55.8794 138.107V88.435C55.8794 87.8487 56.3591 87.4224 56.892 87.4224H141.26C141.847 87.4224 142.273 87.902 142.273 88.435V138.107C142.273 138.64 141.793 139.12 141.26 139.12Z",
    fill: "#F58120"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M140.667 138.533H57.4709C56.9379 138.533 56.4583 138.107 56.4583 137.521V88.9145C56.4583 88.3815 56.8846 87.9019 57.4709 87.9019H140.72C141.253 87.9019 141.733 88.3282 141.733 88.9145V137.521C141.679 138.054 141.253 138.533 140.667 138.533Z",
    fill: "#FFE1CA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M151.381 142.851H46.7065V146.848H151.381V142.851Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M147.65 149.087H50.4906L46.7065 146.848H151.434L147.65 149.087Z",
    fill: "#B6CBD3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.198 142.851H86.948V144.823H111.198V142.851Z",
    fill: "#B6CBD3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9275 100.374H29.0029V121.959H60.9275V100.374Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9275 100.374V121.959L44.9919 111.193L29.0029 100.374H60.9275Z",
    fill: "#F4F4F4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9275 100.374L44.9919 111.193L29.0029 100.374H60.9275Z",
    fill: "#F9921E"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M108.371 115.137L90.8365 139.12H69.4114L94.3541 104.904L108.371 115.137Z",
    fill: "#353535"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M108.367 115.137L90.8323 139.12H82.5181L102.877 111.14L108.367 115.137Z",
    fill: "#282828"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M110.715 110.066L98.4421 101.116L95.2077 105.552L107.481 114.501L110.715 110.066Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M107.85 113.97L95.5774 105.021L95.2006 105.538L107.474 114.487L107.85 113.97Z",
    fill: "#E2E2E2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M114.335 104.3L102.88 95.947L98.8604 101.459L110.315 109.812L114.335 104.3Z",
    fill: "#FEBD8F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M110.738 109.195L99.283 100.842L98.8747 101.401L110.33 109.754L110.738 109.195Z",
    fill: "#F9B485"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M110.609 77.7759L101.175 90.7269C100.802 91.2599 100.642 91.9527 100.749 92.5923L101.761 97.4423L112.527 82.6791C113.593 81.1868 113.273 79.1083 111.781 78.0423L111.301 77.6693C111.088 77.5094 110.768 77.5627 110.609 77.7759Z",
    fill: "#FEBD8F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M122.18 104.371L100.169 88.2755L106.831 79.1085L128.842 95.2041C129.375 95.5771 129.482 96.3766 129.109 96.9095L123.886 104.105C123.459 104.638 122.713 104.744 122.18 104.371Z",
    fill: "#F9921E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M105.173 99.9476L101.762 97.4426L114.233 80.3345C114.926 79.3751 116.258 79.1619 117.218 79.8548C118.177 80.5476 118.39 81.8801 117.697 82.8394L105.173 99.9476Z",
    fill: "#FEBD8F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M108.644 102.452L105.233 99.9473L117.171 83.532C117.864 82.5726 119.196 82.3594 120.156 83.0523C121.115 83.7452 121.328 85.0776 120.635 86.0369L108.644 102.452Z",
    fill: "#FEBD8F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M112.046 104.957L108.635 102.452L119.827 87.1564C120.52 86.197 121.853 85.9838 122.812 86.6767C123.771 87.3695 123.984 88.702 123.292 89.6613L112.046 104.957Z",
    fill: "#FEBD8F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M123.194 89.608L112.002 104.904L112.854 105.544C114.293 106.556 116.212 106.343 117.225 105.011L118.078 103.785L126.605 92.1129C127.298 91.1536 127.085 89.8212 126.125 89.1283C125.219 88.4887 123.887 88.7019 123.194 89.608Z",
    fill: "#FEBD8F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7136 88.4355L106.241 76.7635C107.36 77.563 107.573 79.1086 106.774 80.2278L101.178 87.8492C100.378 89.0217 98.8328 89.2349 97.7136 88.4355Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9754 90.8868L83.3821 83.905C82.3161 83.1055 82.0497 81.6132 82.8491 80.5473L94.2013 64.9847C95.0007 63.9188 96.493 63.6523 97.5589 64.4518L107.152 71.4336C108.218 72.2331 108.485 73.7254 107.685 74.7913L96.3331 90.3538C95.5337 91.4198 94.0414 91.6863 92.9754 90.8868Z",
    fill: "#F9921E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M107.678 74.7914L96.3258 90.3539C95.5264 91.4199 94.0341 91.6864 92.9681 90.8869L90.9429 89.3946L105.12 69.9414L107.145 71.4337C108.211 72.2332 108.424 73.7255 107.678 74.7914Z",
    fill: "#F78A1C"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8023 91.5799L84.2847 89.0217C82.6858 87.8492 82.3127 85.6107 83.4853 84.0118L92.8121 90.8338C91.6396 92.3794 89.4012 92.7525 87.8023 91.5799Z",
    fill: "#F77C21"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M102.88 35.5118C102.88 35.5118 106.557 52.1936 97.6035 64.5051L107.037 71.3804C115.991 59.0689 132.992 57.47 132.992 57.47L102.88 35.5118Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M133.038 57.47C133.038 57.47 116.037 59.0689 107.083 71.3803L104.205 69.2485C111.347 59.8683 122.486 55.9777 128.935 54.4854L133.038 57.47Z",
    fill: "#F4F4F4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M132.034 58.3763L102.348 36.7379C101.975 36.4714 101.922 35.9385 102.188 35.6187C102.455 35.2456 102.987 35.1923 103.307 35.4588L132.993 57.0972C133.366 57.3636 133.42 57.8966 133.153 58.2164C132.94 58.5362 132.407 58.6428 132.034 58.3763Z",
    fill: "#F77C21"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M104.317 117.908C103.784 118.654 102.665 118.814 101.919 118.281C101.173 117.748 101.013 116.629 101.546 115.883C102.079 115.137 103.198 114.977 103.944 115.51C104.744 116.043 104.904 117.109 104.317 117.908Z",
    fill: "#565656"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M100.954 122.545C100.421 123.291 99.3022 123.451 98.556 122.918C97.8099 122.385 97.65 121.266 98.183 120.52C98.7159 119.774 99.8352 119.614 100.581 120.147C101.327 120.68 101.487 121.746 100.954 122.545Z",
    fill: "#565656"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M126.497 93.5261L125.937 93.1179L119.249 102.29L119.808 102.699L126.497 93.5261Z",
    fill: "#EA821B"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M112.274 83.1399L111.714 82.7317L105.026 91.9042L105.586 92.3125L112.274 83.1399Z",
    fill: "#EA821B"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M39.4083 55.5921C40.0834 52.6968 38.2836 49.8024 35.3883 49.1272C32.493 48.4521 29.5985 50.2519 28.9234 53.1472C28.2482 56.0425 30.048 58.937 32.9434 59.6121C35.8387 60.2873 38.7331 58.4875 39.4083 55.5921Z",
    fill: "#FFE1CA"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M33.2698 52.01C33.2698 52.7562 32.6835 53.3424 31.9374 53.3424C31.1912 53.3424 30.605 52.7562 30.605 52.01C30.605 51.2639 31.1912 50.6776 31.9374 50.6776C32.6835 50.6776 33.2698 51.2639 33.2698 52.01Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1742 47.1074C30.1236 47.1074 26.8726 50.3585 26.8726 54.409C26.8726 58.1398 29.6973 61.231 33.3214 61.6574V64.1623H35.0269V61.6574C38.6511 61.231 41.4758 58.1398 41.4758 54.409C41.4225 50.3585 38.1714 47.1074 34.1742 47.1074ZM34.1742 59.792C31.1896 59.792 28.7912 57.3936 28.7912 54.409C28.7912 51.4244 31.1896 49.0261 34.1742 49.0261C37.1588 49.0261 39.5571 51.4244 39.5571 54.409C39.5571 57.3936 37.1055 59.792 34.1742 59.792Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1622 48.4921C30.9112 48.4921 28.2463 51.1569 28.2463 54.408C28.2463 57.6591 30.9112 60.3239 34.1622 60.3239C37.4133 60.3239 40.0782 57.6591 40.0782 54.408C40.0782 51.1569 37.4133 48.4921 34.1622 48.4921ZM34.1622 59.7909C31.1776 59.7909 28.7793 57.3926 28.7793 54.408C28.7793 51.4234 31.1776 49.025 34.1622 49.025C37.1468 49.025 39.5452 51.4234 39.5452 54.408C39.5452 57.3926 37.0936 59.7909 34.1622 59.7909Z",
    fill: "#F4F4F4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1759 74.8212C33.4298 74.8212 32.8435 74.235 32.8435 73.4888V63.1493H35.5083V73.4888C35.5083 74.1817 34.8688 74.8212 34.1759 74.8212Z",
    fill: "#080C51"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5083 63.1493H32.8435V63.5224H35.5083V63.1493Z",
    fill: "#333866"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6878 48.7825C91.6878 46.171 89.5559 44.0924 86.9977 44.0924C84.3862 44.0924 82.3076 46.2243 82.3076 48.7825C82.3076 50.5946 83.3203 52.1935 84.8658 52.9396V54.805H89.1829V52.9396C90.6752 52.1935 91.6878 50.5946 91.6878 48.7825Z",
    fill: "#FFDA00"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3431 56.0316H84.5997C84.3865 56.0316 84.1733 55.8184 84.1733 55.6052C84.1733 55.392 84.3865 55.1788 84.5997 55.1788H89.3431C89.5563 55.1788 89.7695 55.392 89.7695 55.6052C89.7695 55.8717 89.6096 56.0316 89.3431 56.0316Z",
    fill: "#080C51"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3431 54.9121H84.5997C84.3865 54.9121 84.1733 54.6989 84.1733 54.4857C84.1733 54.2725 84.3865 54.0593 84.5997 54.0593H89.3431C89.5563 54.0593 89.7695 54.2725 89.7695 54.4857C89.7695 54.7522 89.6096 54.9121 89.3431 54.9121Z",
    fill: "#1E334E"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3431 57.2036H84.5997C84.3865 57.2036 84.1733 56.9904 84.1733 56.7772C84.1733 56.564 84.3865 56.3508 84.5997 56.3508H89.3431C89.5563 56.3508 89.7695 56.564 89.7695 56.7772C89.7695 56.9904 89.6096 57.2036 89.3431 57.2036Z",
    fill: "#1E334E"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5938 57.5767C88.5938 58.4827 87.8476 59.1756 86.9949 59.1756C86.0889 59.1756 85.396 58.4294 85.396 57.5767H88.5938Z",
    fill: "#1E334E"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M85.3422 106.023C85.3422 106.983 85.2356 107.836 84.9691 108.742C83.7966 112.899 80.0125 115.883 75.4823 115.883C72.1246 115.883 69.14 114.178 67.3813 111.62C66.3153 110.021 65.6758 108.102 65.6758 106.077C65.6758 100.641 70.0994 96.2169 75.5356 96.2169V106.077L84.0098 101.12C84.8625 102.506 85.3422 104.211 85.3422 106.023Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M84.8587 99.3078C83.1532 96.3765 80.0087 94.4045 76.3845 94.4045V104.264L84.8587 99.3078Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M85.3367 106.023C85.3367 106.982 85.2301 107.835 84.9636 108.741L75.4768 106.023L83.9509 101.067C84.857 102.506 85.3367 104.211 85.3367 106.023Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M75.4823 96.1635V106.023L67.3813 111.566C66.3153 109.967 65.6758 108.049 65.6758 106.023C65.6758 100.587 70.0461 96.1635 75.4823 96.1635Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M128.993 117.269H110.126V136.243H128.993V117.269Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M128.993 117.269H110.126V119.774H128.993V117.269Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M111.618 119.081C111.913 119.081 112.151 118.842 112.151 118.548C112.151 118.253 111.913 118.015 111.618 118.015C111.324 118.015 111.085 118.253 111.085 118.548C111.085 118.842 111.324 119.081 111.618 119.081Z",
    fill: "#33C3EF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M113.913 118.548C113.913 118.867 113.7 119.081 113.38 119.081C113.061 119.081 112.847 118.867 112.847 118.548C112.847 118.228 113.061 118.015 113.38 118.015C113.647 118.015 113.913 118.228 113.913 118.548Z",
    fill: "#33C3EF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M115.613 118.548C115.613 118.867 115.399 119.081 115.08 119.081C114.813 119.081 114.547 118.867 114.547 118.548C114.547 118.228 114.76 118.015 115.08 118.015C115.399 118.015 115.613 118.228 115.613 118.548Z",
    fill: "#33C3EF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M115.172 124.107H113.385L112.984 125.22H112.404L114.033 120.955H114.525L116.157 125.22H115.58L115.172 124.107ZM113.555 123.644H115.005L114.279 121.649L113.555 123.644Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M127.445 121.586H118.917V122.119H127.445V121.586Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M127.445 123.025H118.917V123.558H127.445V123.025Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M127.445 124.517H118.917V125.05H127.445V124.517Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M127.445 125.956H118.917V126.489H127.445V125.956Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M127.445 127.395H118.917V127.928H127.445V127.395Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M127.456 128.834H111.627V129.367H127.456V128.834Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M127.456 130.327H111.627V130.86H127.456V130.327Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M127.456 131.765H111.627V132.298H127.456V131.765Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M127.456 133.204H111.627V133.737H127.456V133.204Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M173.6 48.8359L166.298 52.0337L168.163 53.4194L161.555 62.4798L156.918 59.1222L137.038 86.25L139.703 88.222L157.611 63.7056L162.248 67.1166L170.828 55.3914L172.694 56.7238L173.6 48.8359Z",
    fill: "#FFE1CA"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M182.075 76.5499H131.336V122.118H182.075V76.5499Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M182.075 76.5499H131.336V80.7071H182.075V76.5499Z",
    fill: "#1E334E"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M136.933 78.6286C136.933 79.1083 136.56 79.4814 136.08 79.4814C135.6 79.4814 135.227 79.1083 135.227 78.6286C135.227 78.149 135.6 77.7759 136.08 77.7759C136.56 77.7226 136.933 78.149 136.933 78.6286Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M140.345 78.628C140.345 79.1077 139.972 79.4808 139.492 79.4808C139.012 79.4808 138.639 79.1077 138.639 78.628C138.639 78.1483 139.012 77.7753 139.492 77.7753C139.972 77.7753 140.345 78.1483 140.345 78.628Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M143.707 78.6286C143.707 79.1083 143.334 79.4814 142.855 79.4814C142.375 79.4814 142.002 79.1083 142.002 78.6286C142.002 78.149 142.375 77.7759 142.855 77.7759C143.334 77.7226 143.707 78.149 143.707 78.6286Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M148.18 85.8232H135.176V98.8276H148.18V85.8232Z",
    fill: "#F58120"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M141.678 104.317C138.107 104.317 135.176 107.248 135.176 110.819C135.176 112.205 135.602 113.537 136.349 114.603C137.521 116.255 139.44 117.321 141.625 117.321C145.196 117.321 148.127 114.39 148.127 110.819C148.234 107.195 145.302 104.317 141.678 104.317ZM141.678 112.898C140.985 112.898 140.346 112.525 139.973 112.045C139.706 111.725 139.6 111.299 139.6 110.819C139.6 109.647 140.559 108.741 141.678 108.741C142.851 108.741 143.757 109.647 143.757 110.819C143.81 111.938 142.851 112.898 141.678 112.898Z",
    fill: "#FFDA00"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M144.343 91.153L142.797 93.6046L139.44 88.3282L135.176 94.9903V98.8277H148.234V97.1755L144.343 91.153Z",
    fill: "#FFE1CA"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M148.18 97.9214H135.176V98.8274H148.18V97.9214Z",
    fill: "#359B8C"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M146.792 88.2219C146.792 88.8081 146.312 89.3411 145.673 89.3411C145.087 89.3411 144.554 88.8614 144.554 88.2219C144.554 87.6356 145.033 87.1027 145.673 87.1027C146.312 87.156 146.792 87.6356 146.792 88.2219Z",
    fill: "#FFE1CA"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M165.184 85.8232H151.061V86.3562H165.184V85.8232Z",
    fill: "#7F7F7F"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M178.029 87.2623H151.061V87.7953H178.029V87.2623Z",
    fill: "#B6CBD3"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M174.724 88.7017H151.061V89.2346H174.724V88.7017Z",
    fill: "#B6CBD3"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M178.029 90.1937H151.061V90.7267H178.029V90.1937Z",
    fill: "#B6CBD3"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M172.219 91.6323H151.061V92.1653H172.219V91.6323Z",
    fill: "#B6CBD3"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M178.029 93.0717H151.061V93.6046H178.029V93.0717Z",
    fill: "#B6CBD3"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M178.029 94.564H151.061V95.0969H178.029V94.564Z",
    fill: "#B6CBD3"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M178.029 96.0034H151.061V96.5364H178.029V96.0034Z",
    fill: "#B6CBD3"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M178.029 97.4417H151.061V97.9746H178.029V97.4417Z",
    fill: "#B6CBD3"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M178.029 98.8807H151.061V99.4137H178.029V98.8807Z",
    fill: "#B6CBD3"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M165.184 103.997H151.061V104.53H165.184V103.997Z",
    fill: "#7F7F7F"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M174.405 105.436H151.061V105.969H174.405V105.436Z",
    fill: "#B6CBD3"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M178.029 106.875H151.061V107.408H178.029V106.875Z",
    fill: "#B6CBD3"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M172.219 108.368H151.061V108.901H172.219V108.368Z",
    fill: "#B6CBD3"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M178.029 109.807H151.061V110.34H178.029V109.807Z",
    fill: "#B6CBD3"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M173.179 111.245H151.061V111.778H173.179V111.245Z",
    fill: "#B6CBD3"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M173.179 112.738H151.061V113.271H173.179V112.738Z",
    fill: "#B6CBD3"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M178.029 114.177H151.061V114.71H178.029V114.177Z",
    fill: "#B6CBD3"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M178.029 115.616H151.061V116.149H178.029V115.616Z",
    fill: "#B6CBD3"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M178.029 117.055H151.061V117.588H178.029V117.055Z",
    fill: "#B6CBD3"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M141.678 104.317V108.741C140.506 108.741 139.6 109.647 139.6 110.819C139.6 111.245 139.76 111.672 139.973 112.045L136.349 114.603C135.602 113.537 135.176 112.258 135.176 110.819C135.176 107.195 138.107 104.317 141.678 104.317Z",
    fill: "#F9921E"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2681 127.448H24V149.086H41.2681V127.448Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2681 127.448H24V129.58H41.2681V127.448Z",
    fill: "#34344A"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5884 131.392H28.5225V137.681H29.5884V131.392Z",
    fill: "#F9921E"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5071 133.098H30.4412V137.628H31.5071V133.098Z",
    fill: "#F9921E"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4248 134.537H32.3589V137.681H33.4248V134.537Z",
    fill: "#F9921E"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3523 131.392H34.2864V137.681H35.3523V131.392Z",
    fill: "#F9921E"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M37.262 131.392H36.196V137.681H37.262V131.392Z",
    fill: "#F9921E"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2088 138.161H28.5215V138.534H37.2088V138.161Z",
    fill: "#080C51"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2206 139.92H30.7283V140.453H32.2206V139.92Z",
    fill: "#B6CBD3"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7251 141.358H25.0757V141.891H30.7251V141.358Z",
    fill: "#B6CBD3"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2707 144.29H25.0757V144.823H32.2707V144.29Z",
    fill: "#B6CBD3"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6185 145.728H25.0757V146.261H30.6185V145.728Z",
    fill: "#B6CBD3"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2707 147.168H25.0757V147.701H32.2707V147.168Z",
    fill: "#B6CBD3"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M36.208 139.92H33.0103V140.453H36.208V139.92Z",
    fill: "#B6CBD3"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7264 139.92H36.5286V140.453H39.7264V139.92Z",
    fill: "#B6CBD3"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2053 141.358H33.0103V141.891H40.2053V141.358Z",
    fill: "#B6CBD3"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2053 142.798H33.0103V143.331H40.2053V142.798Z",
    fill: "#B6CBD3"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2053 144.29H33.0103V144.823H40.2053V144.29Z",
    fill: "#B6CBD3"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5531 145.728H33.0103V146.261H38.5531V145.728Z",
    fill: "#B6CBD3"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2053 147.168H33.0103V147.701H40.2053V147.168Z",
    fill: "#B6CBD3"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4462 139.92H25.0632V140.453H30.4462V139.92Z",
    fill: "#B6CBD3"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9132 142.798H25.0632V143.331H29.9132V142.798Z",
    fill: "#B6CBD3"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2222 129.047C25.5165 129.047 25.7551 128.809 25.7551 128.514C25.7551 128.22 25.5165 127.981 25.2222 127.981C24.9278 127.981 24.6892 128.22 24.6892 128.514C24.6892 128.809 24.9278 129.047 25.2222 129.047Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5742 128.514C27.5742 128.781 27.361 129.047 27.0413 129.047C26.7748 129.047 26.5083 128.834 26.5083 128.514C26.5083 128.248 26.7215 127.981 27.0413 127.981C27.361 127.981 27.5742 128.195 27.5742 128.514Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9058 129.047C29.2001 129.047 29.4387 128.809 29.4387 128.514C29.4387 128.22 29.2001 127.981 28.9058 127.981C28.6114 127.981 28.3728 128.22 28.3728 128.514C28.3728 128.809 28.6114 129.047 28.9058 129.047Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M138.326 29.9159C138.326 26.6648 134.489 24 129.799 24C125.109 24 121.271 26.6115 121.271 29.9159C121.271 32.6873 124.043 34.9791 127.774 35.6186C127.774 36.4714 127.347 37.484 125.482 38.017C125.482 38.017 129.746 38.6565 130.652 35.7785C134.915 35.512 138.326 33.0071 138.326 29.9159Z",
    fill: "#FFE1CA"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M125.316 31.1415C125.935 31.1415 126.436 30.6404 126.436 30.0223C126.436 29.4042 125.935 28.9031 125.316 28.9031C124.698 28.9031 124.197 29.4042 124.197 30.0223C124.197 30.6404 124.698 31.1415 125.316 31.1415Z",
    fill: "#F9921E"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M130.909 30.0223C130.909 30.6619 130.376 31.1415 129.79 31.1415C129.15 31.1415 128.67 30.6086 128.67 30.0223C128.67 29.3827 129.203 28.9031 129.79 28.9031C130.376 28.9031 130.909 29.3827 130.909 30.0223Z",
    fill: "#F9921E"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M134.22 31.1415C134.838 31.1415 135.339 30.6404 135.339 30.0223C135.339 29.4042 134.838 28.9031 134.22 28.9031C133.601 28.9031 133.1 29.4042 133.1 30.0223C133.1 30.6404 133.601 31.1415 134.22 31.1415Z",
    fill: "#F9921E"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M164.164 139.227H160.753V149.14H164.164V139.227Z",
    fill: "#F9921E"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M169.383 135.656H165.972V149.087H169.383V135.656Z",
    fill: "#F9921E"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M174.557 137.148H171.146V149.14H174.557V137.148Z",
    fill: "#F9921E"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M179.728 130.913H176.317V149.14H179.728V130.913Z",
    fill: "#FFDA00"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M162.146 138.321L168.062 130.007L172.698 133.365L177.815 126.17",
    stroke: "#F58120",
    strokeWidth: 1.0507,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M174.945 126.596L177.823 126.17L178.25 128.994",
    stroke: "#F58120",
    strokeWidth: 1.0507,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M81.6159 70.4742H39.8848V74.738H81.6159V70.4742Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6151 70.4742H70.7427V74.738H81.6151V70.4742Z",
    fill: "#1E334E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignRecommendations);
export default __webpack_public_path__ + "static/media/campaignRecommendations.d075d29147d4768daadb2eb0bfcd5eef.svg";
export { ForwardRef as ReactComponent };